module.exports = __webpack_public_path__ + "img/Philips423_disk.656607ab.png";